import clsx from 'clsx';
import React, { useState } from 'react';
import './ButtonIncrementDecrement.scss';
import { UiButton } from '@open-stack/ui';

interface Props {
    multiplier?: number;
    count: number;
    max?: number;

    onIncrement(amount: number): void;

    onDecrement(amount: number): void;

    disableX10?: boolean;
    disabled?: boolean;
    showZero?: boolean;
}

export function ButtonIncrementDecrement({
    multiplier = 1,
    count = 0,
    max,
    onIncrement,
    onDecrement,
    disableX10,
    disabled,
    showZero = false,
}: Props) {
    const [isExtraButtonsVisible, setIsExtraButtonsVisible] = useState(false);

    const singleUnitAmount = multiplier || 1;
    let label = count / singleUnitAmount;
    label = (label % 1 > 0 ? label.toFixed(1) : label) as any;

    const isDecrementDisabled = disabled || count === 0;
    const isIncrementDisabled = Boolean(disabled || (max && max <= count));

    function increment(units = 1) {
        const amountToIncrement = units * singleUnitAmount;
        onIncrement(amountToIncrement);
    }

    function decrement(units = 1) {
        const amountToDecrement = units * singleUnitAmount;
        const resultAmount = count - amountToDecrement;

        if (resultAmount < 0) {
            onDecrement(amountToDecrement + resultAmount);
        } else {
            const remainder = count % singleUnitAmount;

            if (remainder > 0) {
                onDecrement(remainder);
            } else {
                onDecrement(amountToDecrement);
            }
        }
    }

    function wrapClick(callback) {
        return (event) => {
            event.stopPropagation();
            callback();
        };
    }

    const isExtraContainerVisible = showZero || count > 0;

    return (
        <div className="ButtonIncrementDecrement">
            {!disableX10 && isExtraButtonsVisible && (
                <div className="upper-row button-group animated fadeInUp">
                    <UiButton onClick={wrapClick(() => setIsExtraButtonsVisible(false))} icon="close" />

                    <UiButton disabled={isDecrementDisabled} onClick={wrapClick(() => decrement(10))}>
                        -10
                    </UiButton>

                    <UiButton onClick={wrapClick(() => increment(10))} disabled={isIncrementDisabled}>
                        +10
                    </UiButton>
                </div>
            )}

            <div className={clsx(isExtraContainerVisible && 'button-group')}>
                {isExtraContainerVisible && (
                    <>
                        <UiButton
                            icon="remove"
                            className="button-decrement"
                            disabled={isDecrementDisabled}
                            onClick={wrapClick(() => decrement(1))}
                        />

                        <UiButton
                            className="button-label"
                            //color="primary"
                            variant="filled"
                            onClick={wrapClick(() => setIsExtraButtonsVisible(!isExtraButtonsVisible))}>
                            {label}
                        </UiButton>
                    </>
                )}

                <UiButton
                    icon="add"
                    className="button-increment"
                    onClick={wrapClick(() => increment(1))}
                    disabled={isIncrementDisabled}
                />
            </div>
        </div>
    );
}
